export const sentimentsCount = sentiments => sentiments.reduce((acc, { value }) => acc + value, 0);
